module.exports = __webpack_public_path__ + "static/fonts/MicrosoftYaHei.c2db9c4.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/MicrosoftYaHei.ttf
// module id = O2lu
// module chunks = 1